import { Box, Image } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import useCheckLogin from "../../../hook/useCheckLogin";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openLanguagePop } from "../../../redux/action/member/memberAction";

const LngButton = () => {
  // 取 登入狀態 機台相關的狀態
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const dispatch = useDispatch();

  const iconSize = useMemo(() => {
    return {
      base: "50px",
      md: "50px",
      xl: isMachineUser ? "80px" : "80px",
    };
  }, [isMachineUser]);

  const iconHeightSize = useMemo(() => {
    return {
      base: "40px",
      md: "40px",
      xl: isMachineUser ? "55px" : "55px",
    };
  }, [isMachineUser]);

  const onClick = () => {
    dispatch(openLanguagePop());
  };

  return (
    <Box
      onClick={onClick}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={`${COMMON_WEB_PATH}/now888/lng/lng_icon.png`}
        height={iconHeightSize}
        minW={iconSize}
        maxW={iconSize}
      />
    </Box>
  );
};

export default LngButton;
